<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
// import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
// import Multiselect from "@vueform/multiselect";
// import moment from "moment";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import DxButton from "devextreme-vue/button";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Performance Alterada",
    // meta: [{ name: "description", content: appConfig.description }]
  },
  // components: { Layout, PageHeader, Loader, Vue3Lottie },
  components: {
    DxButton,
    Layout, PageHeader, DxToolbar, DxItem,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxPager, DxFilterRow, DxRemoteOperations,
    Loader
  },

  data() {
    return {
      title: "Previsão Alterada",
      items: [
        {
          text: "Previsão",
          href: "/"
        },
        {
          text: "Alterada",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,
      selectedItems: [],
    };
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    // console.log('mounted data-agendamento_0')
    this.atualizaDataList()
  },

  methods: {

    onPageChange() {
      // console.log('onPageChange')
      // console.log(this.currentPage)
      this.atualizaDataList()
    },

    confirmarPeriodo() {
      // console.log('confirmarPeriodo')
      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    carregouGrid(e) {
      // console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Previsão Alterada: ${dtIniFormated} - ${dtFimFormated}`

    },

    atualizaDataList() {
      // console.log('atualizaDataList_cli')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        // console.log('cookie dataMov não existe, criando')
        // console.log('sem filtro')
        let perIniPadrao = moment(new Date())
          .add(-7, 'days')
          .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
          .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        // console.log('sem filtro')
        let perIniPadrao = moment(new Date())
          .add(-7, 'days')
          .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
          .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "mov_id",
        load: function (loadOptions) {

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }

          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          return api.get(`${getBaseUrl()}api/movagenda`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response.data)
            return {
              data: response.data[0],
              totalCount: response.data[1]
            }
          }).catch((e) => {
            console.log('error dt agendamento list')
            console.log(e)
          })
        },
      })
    },

    onSelectionChanged(e) {
      // Opcional: Gerenciar alterações de seleção em tempo real
      this.selectedItems = e.selectedRowKeys;
      // console.log(this.selectedItems)
    },

    sendSelectedRows() {
      // console.log('selectedRows')
      let ids = this.selectedItems
      ids.forEach(id => {
        // console.log(id)
        api.post(`${getBaseUrl()}api/dblatualizadtprev/`, {
          params: {
            'ids': id
          }
        }).then(response => {
          console.log('response.data')
          console.log(response.data)
          
        
        })
        
      })
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: 'A data de previsão foi atualizada com sucesso!',
        showConfirmButton: false,
        timer: 1500
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      // this.$router.push(`/movimento/editar/${idData}`)
      const routeData = this.$router.resolve(`/movimento/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      // console.log('onCellPrepared')
      // console.log(e)
      if (e.rowType === "data") {
        if (e.column.dataField === "dtagendamento") {
          const dtagendamento = Date.parse(e.data.dtagendamento)
          const dtpreventrega = Date.parse(e.data.dtpreventrega)
          const processado = e.data.processado
          console.log('dtagendamento')
          console.log(typeof dtagendamento)
          let corDif = null
          if (dtagendamento > dtpreventrega) {
            corDif = 'rgb(248,101,101)'
          } else {
            corDif = 'rgba(125,189,110)'
          }

          if (processado) {
            corDif = 'rgb(5, 126, 236)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDif}`;
        }
      }
    },

    onExporting(e) {
      // console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      // console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      let date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true" />

    <div>
      <DxToolbar>

        <DxItem location="before" widget="dxButton">
          <DxButton icon="refresh" hint="Redefinir formatação de tabela para padrão" :on-click="refeFormTable" />
        </DxItem>
      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">
      <DxButton text="Enviar Seleções" type="success" @click="sendSelectedRows" />

      <DxDataGrid ref="dataGridRefKey" :data-source="dataList" :show-borders="true" :focused-row-enabled="true"
        :column-auto-width="true" :show-row-lines="true" :allow-column-reordering="true" :allow-column-resizing="true"
        :row-alternation-enabled="true" @cell-prepared="onCellPrepared" @content-ready="carregouGrid"
        @exporting="onExporting" @row-dbl-click="onRowDblClick" @selectionChanged=onSelectionChanged>

        <DxRemoteOperations :filtering="true" :paging="true" :sorting="true" :summary="true" :grouping="false"
          :group-paging="false" />


        <DxColumnChooser :enabled="true" />
        <DxColumnFixing :enabled="true" />
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple" showCheckBoxesMode="onClick" v-model="selectedItems" />
        <!--:allow-select-all="false"-->
        <DxExport :enabled="true" :allow-export-selected-data="true" />
        <DxStateStoring :enabled="true" type="sessionStorage" storage-key="strMovList" />

        <DxGroupPanel :visible="true" />
        <DxGrouping />

        <DxColumn data-field="row_id" :width="330" caption="Movimentos" alignment="center"
          :allowHeaderFiltering="false">

          <DxColumn data-field="mov_id" sort-order="desc" caption="ID" data-type="number" alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />

          <DxColumn data-field="nNF" caption="Número de NF" alignment="right" data-type="text"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />

          <DxColumn data-field="dtemissnf" caption="Data emissão de NFe" alignment="right" data-type="datetime"
            format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true" />

          <DxColumn data-field="nCT" caption="Número de CT" alignment="right" data-type="text"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />

          <DxColumn data-field="dtemissct" caption="Data de emissão de CTe" alignment="right" data-type="datetime"
            format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true" />

          <!-- <DxColumn data-field="transp_nome" caption="Nome da Transportadora" alignment="right" data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']" />
             -->
          <DxColumn data-field="transp_nome" caption="Nome da Transportadora" alignment="right" data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']" />

          <DxColumn data-field="dtpreventrega" caption="Data previsão de entrega" alignment="right" data-type="datetime"
            format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />

          <DxColumn data-field="dtagendamento" caption="Data de agendamento" alignment="right" data-type="datetime"
            format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']" />
          <!-- <DxColumn data-field="mov_valorfrete" caption="Frete Loja" alignment="right" :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']" :allowHeaderFiltering="true" />

          <DxColumn data-field="mov_dtentrega" caption="Dt Entrega" alignment="right" data-type="datetime"
              format="dd/MM/yyyy" :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true" /> -->
        </DxColumn>

        <DxPager :visible="true" :show-page-size-selector="true" :allowed-page-sizes="[10, 30, 50, 100]"
          :show-navigation-buttons="true" :show-info="true" />


      </DxDataGrid>
    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input id="dtIniFiltro" v-model="dtIniFiltro" type="date" class="form-control" placeholder="Data Início"
              :class="{ 'is-invalid': submittedPeriodo && !dtIniFiltro, }" />
            <div v-if="submittedPeriodo && !dtIniFiltro" class="invalid-feedback">
              <span>Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input id="dtFimFiltro" v-model="dtFimFiltro" type="date" class="form-control" placeholder="Data Final"
              :class="{ 'is-invalid': submittedPeriodo && !dtFimFiltro, }" />
            <div v-if="submittedPeriodo && !dtFimFiltro" class="invalid-feedback">
              <span>Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>